# UTILS
import './utils.coffee'

# COMMONS
import './common.coffee'

# ATOMS
import '../views/_components/_1-atoms/burger-button/burger-button.coffee'
import '../views/_components/_1-atoms/checkbox/checkbox.coffee'
import '../views/_components/_1-atoms/filter-tag/filter-tag.coffee'
import '../views/_components/_1-atoms/headline/headline.coffee'
import '../views/_components/_1-atoms/image/image.coffee'
import '../views/_components/_1-atoms/input/input.coffee'
import '../views/_components/_1-atoms/link/link.coffee'
import '../views/_components/_1-atoms/mouse-cursor/mouse-cursor.coffee'
import '../views/_components/_1-atoms/milkbox/milkbox.coffee'
import '../views/_components/_1-atoms/page-loader/page-loader.coffee'
import '../views/_components/_1-atoms/read-more-button/read-more-button.coffee'
import '../views/_components/_1-atoms/scroll-down-hint/scroll-down-hint.coffee'
import '../views/_components/_1-atoms/select/select.coffee'
import '../views/_components/_1-atoms/tag/tag.coffee'
import '../views/_components/_1-atoms/tooltip/tooltip.coffee'

# MOLECULES
import '../views/_components/_2-molecules/accordion-entry/accordion-entry.coffee'
import '../views/_components/_2-molecules/animated-cards/animated-cards.coffee'
import '../views/_components/_2-molecules/animated-slots/animated-slots.coffee'
import '../views/_components/_2-molecules/elc-cookie-consent/elc-cookie-consent.coffee'
import '../views/_components/_2-molecules/form-builder/form-builder.coffee'
import '../views/_components/_2-molecules/html-module/html-module.coffee'
import '../views/_components/_2-molecules/image-overlay/image-overlay.coffee'
import '../views/_components/_2-molecules/masonry-images/masonry-images.coffee'
import '../views/_components/_2-molecules/number-text/number-text.coffee'
import '../views/_components/_2-molecules/offer-box/offer-box.coffee'
import '../views/_components/_2-molecules/richtext/richtext.coffee'
import '../views/_components/_2-molecules/scroll-images/scroll-images.coffee'
import '../views/_components/_2-molecules/skill-card/skill-card.coffee'
import '../views/_components/_2-molecules/video-module/video-module.coffee'
import '../views/_components/_2-molecules/vimeo-video/vimeo-video.coffee'
import '../views/_components/_2-molecules/yt-video/yt-video.coffee'

# ORGANISMS
import '../views/_components/_3-organisms/cases-list/cases-list.coffee'
import '../views/_components/_3-organisms/cases-overview/cases-overview.coffee'
import '../views/_components/_3-organisms/featured-case/featured-case.coffee'
import '../views/_components/_3-organisms/header/header.coffee'
import '../views/_components/_3-organisms/media-slider/media-slider.coffee'
import '../views/_components/_3-organisms/numbered-slider/numbered-slider.coffee'
import '../views/_components/_3-organisms/offers/offers.coffee'
import '../views/_components/_3-organisms/offices-overview/offices-overview.coffee'
import '../views/_components/_3-organisms/overlay/overlay.coffee'
import '../views/_components/_3-organisms/page-hero/page-hero.coffee'
import '../views/_components/_3-organisms/scroll-animation/scroll-animation.coffee'
import '../views/_components/_3-organisms/text-image-slider/text-image-slider.coffee'

# initial components binding
window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }